import IQFlow from "./circuits/iqflow.js";

class IQFlow_wrap extends IQFlow {
  constructor(...args) {
    super(...args);

    this.id = "IQFlow";
    this.status = "uninitialized";
    this.name = "airflow";
  }
  async initialize() {
    try {      
      await this.open("/dev/ttyMFC", {
        baudrate: 19200,
        databits: 8,
        parity: "none",
        stopbits: 2         
      });
      this.id = await this.getBHTModelNumber();
      this.serialNumber = await this.getSerialNumber();
      this.selectedFluidName = await this.getSelectedFluidName();
      this.status = "OK";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }
  }
  async update() {
    try {        
      this.value = Math.round((await this.getMeasuredValue()) / 60);
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }      
  }
  async setMLM(value) {
    try {        
      await this.setSetPoint(value*60);
      this.status = "Ok";
    } catch(e) {
      this.status = "Failed";
      throw e;
    }            
  }
  toJSON() {
    return({
      id: this.id,
      serialNumber: this.serialNumber,
      status: this.status,
      value: this.value,
      selectedFluidName: this.selectedFluidName
    });
  }
}

export default IQFlow_wrap;